Origin.bindDataEvent('totalRecordCount', '.data-total-record-count', function(count) {
	// 'this' is a reference to all .data-total-record-count elements when the event was triggered
    $(this)
        .html(Origin.FormatNumber(count))
        .closest('.data-show-label')
            .show();
    
    $(this).siblings('.data-show-label')
        .show().css('visibility', 'visible');
    if (typeof IS_TEAM_USER !== 'undefined') {
        if (IS_TEAM_USER != undefined && IS_TEAM_USER && CRITERIA_EDIT_MODE != undefined && CRITERIA_EDIT_MODE === 'Filter' && initialMatchCount > 0 && initialMatchCount != count) {
            $('.result-name-v2')
                .html(Origin.FormatNumber(count) + ' of ' + Origin.FormatNumber(initialMatchCount));
            $('.result-name-label-suffix').text(' Records');
        } else {
            $('.result-name-label-suffix').text(' Records');
        }
    }
});
/*
Origin.onData('totalRecordCount', function() {
	
	$('a').attr('href', 'http://google.com').addClass('foo')
	
	$('a').each(function() {
		$(this)
			.attr('href', 'http://google.com')
			.addClass('foo');
	});
	
	
	$(this).find('.data-total-record-count').html( ... )
	// 'this' is a reference to the document object
});
*/
Origin.bindDataEvent('emailTemplateLockdown', '.data-email-template-lockdown', function (emailTemplateLockdown) {
    $('#emailTemplateLockdown').attr('emailTemplateLockdown', emailTemplateLockdown);
});
Origin.bindDataEvent('totalEmailCount', '.data-total-email-count', function (count) {
    var classes = ['qtip-salesgenie', 'qtip-email-count'];
    var content = '<div style="text-align:center">' + Origin.FormatNumber(count) + '<br/>emails</div>';
    if (count === 0) {
        content = '0 emails <br/>To send emails, try <br/>expanding your search.';}

    $('span.entity-count').html(Origin.ToShortThousandsFormat(count));
    var $blueBanner = $('.entityCount');
    var $emailIcon = $('.email-blast-icon');
    if ($emailIcon.data('qtip') && $emailIcon.qtip('api') && $emailIcon.qtip('api').elements.content) {
        $emailIcon.qtip('api').elements.content.html(content);
    } else {
        $emailIcon.qtip({
            show: {
                delay: 200,
            },
            hide: {
                delay: 200,
            },
            style: {
                classes: classes.join(' '),
                tip: {
                    width: 19,
                    height: 33
                }
            },
            content: content,
            position: {
                my: 'bottom center',
                at: 'top center'
            }
        });
    }

    $blueBanner.show();
    $('.emailArrow').show();

    if (count == 0) {
    //    $blueBanner.hide();
    //    $('.emailArrow').hide();
        $emailIcon.removeClass('link');
        $emailIcon.removeClass('action-email-blast');
        $emailIcon.attr('title', 'Your search does not have any emails to start a campaign');
    }else {
    //    $blueBanner.show();
    //    $('.emailArrow').show();
        $emailIcon.addClass('link');
        $emailIcon.addClass('action-email-blast');
        $emailIcon.removeAttr('title');
    }
});

Origin.bindDataEvent('totalDisplayCampaignCount', '.data-total-display-campaign-count', function (count) {
    var classes = ['qtip-salesgenie', 'qtip-display-campaign-count'];
    var content = '<div style="text-align:center">' + Origin.FormatNumber(count) + '<br/>display contacts</div>';
    if (count === 0) {
        content = '0 display contacts <br/>To send display campaign, <br/>try expanding your search.';
    }

    $('span.entity-count').html(Origin.ToShortThousandsFormat(count));
    var $blueBanner = $('.entityCount');
    var $displayCampaignIcon = $('.display-campaign-icon');
    if ($displayCampaignIcon.data('qtip') && $displayCampaignIcon.qtip('api') && $displayCampaignIcon.qtip('api').elements.content) {
        $displayCampaignIcon.qtip('api').elements.content.html(content);
    } else {
        $displayCampaignIcon.qtip({
            overwrite: true,
            show: {
                delay: 200,
            },
            hide: {
                delay: 200,
            },
            style: {
                classes: classes.join(' '),
                tip: {
                    width: 19,
                    height: 33
                }
            },
            content: content,
            position: {
                my: 'bottom center',
                at: 'top center'
            }
        });
    }

    $blueBanner.show();
    $('.emailArrow').show();

    if (count == 0) {
        //    $blueBanner.hide();
        //    $('.emailArrow').hide();
        $displayCampaignIcon.removeClass('link');
        $displayCampaignIcon.removeClass('action-display-Campaign');
        $displayCampaignIcon.attr('title', 'Your search does not have any emails to start a campaign');
    } else {
        //    $blueBanner.show();
        //    $('.emailArrow').show();
        $displayCampaignIcon.addClass('link');
        $displayCampaignIcon.addClass('action-display-Campaign');
        $displayCampaignIcon.removeAttr('title');
    }
});


Origin.bindDataEvent('totalPageCount', '.data-total-page-count', function(count) {
	$(this)
		.html(Origin.FormatNumber(count))
		.closest('.data-show-label')
			.show();
});

Origin.bindDataEvent('totalMailCount', '.data-total-mail-count', function (count) {
    var $mailIcon = $('.action-direct-mail');
    
    if (count === 0) {
        $mailIcon.removeClass('link');
//        $mailIcon.removeClass('action-direct-mail');
        $mailIcon.attr('title', 'Your search does not have any addresses to start a mail campaign.');
    } else {
        $mailIcon.addClass('link');
//        $mailIcon.addClass('action-direct-mail');
        $mailIcon.removeAttr('title');
    }

	$mailIcon.find('span.directMailCount').text(Origin.ToShortThousandsFormat(count));	
});

Origin.bindDataEvent('totalPhoneCount', '.data-total-phone-count', function (count) {
    var $phoneIcon = $('.action-dial-multiple');
    
    if (count === 0) {
        $phoneIcon.removeClass('link');
   //     $phoneIcon.removeClass('action-dial-multiple');
        $phoneIcon.attr('title', 'Your search does not have any phone numbers to start a call campaign.');
    } else {
        $phoneIcon.addClass('link');
   //     $phoneIcon.addClass('action-dial-multiple');
        $phoneIcon.removeAttr('title');
    }

    $phoneIcon.find('span.phoneCount').text(Origin.ToShortThousandsFormat(count));
});

Origin.bindDataEvent('currentPage', '.data-current-page', function(count) {
	$(this)
		.html(Origin.FormatNumber(count))
		.closest('.data-show-label')
			.show();
});
/* --- THESE EVENTS NEED TO BE REFACTORED AND REMOVED --- */
Origin.bindDataEvent('streetTotalPageCount', '.data-street-total-page-count', function(count) {
	$(this)
		.html(Origin.FormatNumber(count))
		.closest('.data-show-label')
			.show();
});
Origin.bindDataEvent('streetCurrentPage', '.data-street-current-page', function(count) {
	$(this)
		.html(Origin.FormatNumber(count))
		.closest('.data-show-label')
			.show();
});
/* --- */
Origin.bindDataEvent('downloadPrintThreshold', '.data-download-print-threshold', function(threshold) {
	$(this)
		.html(threshold < 0 ? 'Unlimited' : threshold)
		.closest('.data-show-label')
			.show();
});
Origin.bindDataEvent('businessName', '.data-business-name', function(name) {
	$(this)
		.html(name)
		.closest('.data-show-label')
			.show();
});
Origin.bindDataEvent('businessCityState', '.data-business-city-state', function(text) {
	$(this)
		.html(text)
		.closest('.data-show-label')
			.show();
});